<template>
  <page heading="404 Item Not Found">
    <p>It looks like you're lost.</p>
    <p>Go back <router-link to="/">home</router-link></p>
  </page>
</template>

<script>
import Page from '../../layouts/Page/Page';

export default {
  name: 'FourOhFour',
  components: {
    Page
  }
};
</script>
